import { useOktaAuth } from '@okta/okta-react';
import type { JSX } from 'react';
import type React from 'react';
import { useLocation } from 'react-router';

export const RequiredAuth: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const location = useLocation();
  const { oktaAuth, authState } = useOktaAuth();

  if (!authState) {
    return <div>Loading authentication...</div>;
  }

  if (!authState.isAuthenticated) {
    oktaAuth.setOriginalUri(location.pathname);
    void oktaAuth.signInWithRedirect();

    return null;
  }

  return children;
};
